/* eslint-disable */

/**
 * Create styles for `<PageTip />`
 * @param {Styles} styles The result of `createStyles`
 * @returns The `<PageTip />` styles
 */
const pageTipStyles = ({ theme }) => ({
  rootTip: {
    backgroundColor: theme.palette.grey[`100`],
    padding: theme.spacing(1) * 2,
    borderRadius: theme.spacing(1) / 4,
    marginBottom: theme.spacing(1),
  },
});

export default pageTipStyles;
